import React from 'react';
import WhoIs from '../../components/content/aboutUs/who.is';
import OurTeam from '../../components/content/aboutUs/who.our.team';
import Timeline from '../../components/content/aboutUs/who.timeline';
import Key from '../../components/content/whyLidya/why.key';
import Investors from '../../components/content/aboutUs/who.our.investors';
import Where from '../../components/content/aboutUs/who.where';

const NgAboutUsContainer = () => (
  <>
    <WhoIs />
    <OurTeam />
    <Timeline />
    <Key />
    <Investors />
    <Where />
  </>
);

export default NgAboutUsContainer;
